import React from 'react';
import { AlertDialog } from '@lumx/react';

interface Props {
  isOpen: boolean;
  configName: string;
  fromNodeName: string;
  toNodeName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const MobileConfigConflictDialog: React.FC<Props> = ({ isOpen, configName, fromNodeName, toNodeName, onConfirm, onCancel }) => (
  <AlertDialog
    isOpen={isOpen}
    onClose={onCancel}
    kind="info"
    title="Reassign mobile configuration"
    confirmProps={{ label: 'Reassign', onClick: onConfirm }}
    cancelProps={{ label: 'Cancel', onClick: onCancel }}
  >
    <p style={{ fontSize: 14, color: 'var(--color-dark-l1)', lineHeight: 1.6 }}>
      <strong>{configName}</strong> is currently mapped to <strong>{fromNodeName}</strong>.
    </p>
    <p style={{ marginTop: 8, fontSize: 14, color: 'var(--color-dark-l1)', lineHeight: 1.6 }}>
      Remapping it to <strong>{toNodeName}</strong> will remove it from {fromNodeName}. A mobile configuration can only be mapped to one Org unit or Location at a time.
    </p>
  </AlertDialog>
);

export default MobileConfigConflictDialog;
